import {SystemNotificationDto} from "./systemNotificationDto";
import {DateHelper} from "@npm.chapps.com/chapps.common.angular.library";

export class SystemNotification {
    systemNotificationId: number;
    reference: string;
    title: string;
    message: string;
    showFrom: Date;
    showUntil: Date;
    severity: string;
    displayType: string;

    public get isActive(): boolean {
        return this.showFrom < DateHelper.now
            && this.showUntil > DateHelper.now;
    }
    
    public static unmarshallFrom(dto: SystemNotificationDto): SystemNotification {
        const entity = new SystemNotification();
        Object.assign(entity, dto);
        entity.showFrom = new Date(dto.showFrom);
        entity.showUntil = new Date(dto.showUntil); 
        return entity;
    }
}